"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetManagementMessage = void 0;
var asset_management_message_1 = require("./asset-management-message");
Object.defineProperty(exports, "AssetManagementMessage", { enumerable: true, get: function () { return asset_management_message_1.AssetManagementMessage; } });
